module.exports = __webpack_public_path__ + "static/media/inbound-opt-in.f424c7f1.svg";